import { render, staticRenderFns } from "./JikuStairs.vue?vue&type=template&id=584fce90&scoped=true&"
import script from "./JikuStairs.vue?vue&type=script&lang=js&"
export * from "./JikuStairs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584fce90",
  null
  
)

export default component.exports